// frontend/src/pages/maritime-ai/MaritimeAI.jsx

import React from 'react';
import { Wrench, Search, Anchor } from 'lucide-react';
import { HashLink } from 'react-router-hash-link';

const servicesData = [
  {
    title: "Predictive Maintenance And Repair Advisor Agent",
    description: "Optimize maintenance schedules, predict equipment failures, and streamline repair processes.",
    details: ["Predictive maintenance workflows", "Diagnostics On-demand", "Inventory management optimization"],
    icon: Wrench,
  },
  {
    title: "AI Agents for Ship Inspectors",
    description: "Enhance inspection accuracy, automate reporting, and ensure compliance with maritime regulations.",
    details: [ "Automated inspection reports", "Regulatory compliance checking"],
    icon: Search,
  },
  {
    title: "AI Agents for Ship Captains",
    description: "Improve navigation, optimize route planning, and enhance onboard decision-making processes.",
    details: ["Advanced weather routing", "Fuel consumption optimization", "Real-time risk assessment"],
    icon: Anchor,
  },
];

export default function Services() {
  return (
    <section className="py-12" style={{ backgroundColor: '#CCC9AF' }} id="maritime-ai">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-8">Vertical AI Agents for Maritime Industry</h2>
        <p className="text-xl mb-12 text-center text-muted-foreground">
              Revolutionize your maritime operations with our specialized AI agents, designed to enhance efficiency,
              safety, and decision-making across key roles.
        </p>
        {/* Grid layout: 3 columns on md+ screens, 1 column on small screens */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
            {servicesData.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-6 flex flex-col h-full">
                  <div className="flex justify-center mb-4">
                    <service.icon className="w-12 h-12 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-left">{service.title}</h3>
                  <p className="text-gray-600 mb-4 text-left">{service.description}</p>
                  <ul className="list-disc list-inside text-left ml-4 mb-4">
                    {service.details.map((detail, i) => (
                      <li key={i} className="text-muted-foreground">
                        {detail}
                      </li>
                  ))}
                  </ul>
                  <HashLink
                    smooth
                    to="/#contact"
                    className="mt-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                  Learn More
                  </HashLink>
              </div>
           ))}
         </div>

      </div>
    </section>
  );
}





